<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        formLayout="inline"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button type="primary" class="add-btn" icon="plus" @click="upload">
          上传
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:type="{ tableRow }">
          <span>{{ tableRow.type | formatTypeList }}</span>
        </template>
        <template v-slot:action="{ tableRow }">
          <div>
            <a-button
              type="link"
              size="small"
              @click="handleDownload(tableRow)"
            >
              下载
            </a-button>
          </div>
        </template>
      </TableView>
    </a-card>

    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      title="批量运行"
      :maskClosable="false"
    >
      <a-form :form="modalForm" :labelCol="{ span: 4 }">
        <a-form-item label="文件类型" :wrapperCol="{ span: 20 }">
          <a-select
            v-decorator="$decorator('type', '请选择文件类型')"
            allowClear
          >
            <a-select-option v-for="item in typeList" :key="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="模板下载">
          <a-button type="link" @click="handleTemplateDownload">
            点击下载
          </a-button>
        </a-form-item>
        <a-form-item label="附件上传">
          <a-upload
            :beforeUpload="handleBeforeUpload"
            :fileList="fileList"
            :remove="handleRemove"
            multiple
          >
            <a-button>
              <a-icon type="upload" />
              选取文件
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { getTableData, download, templateDownload, upload } from './api'

export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
  },
  data() {
    return {
      tableLoading: true,
      visible: false,
      modalForm: this.$form.createForm(this),
      typeList: [
        {
          label: '企业基本信息',
          value: 1,
        },
        {
          label: '信用主管信息',
          value: 2,
        },
        {
          label: '企业额外信息',
          value: 3,
        },
        {
          label: '企业外部评分信息',
          value: 4,
        },
        {
          label: '评分卡财报数据',
          value: 5,
        },
        {
          label: '企业账户信息',
          value: 6,
        },
        {
          label: '保险',
          value: 7,
        },
        {
          label: '担保',
          value: 17,
        },
        {
          label: '融资数据',
          value: 8,
        },
        {
          label: '内外部评级转化',
          value: 23,
        },
        {
          label: '信用评级',
          value: 25,
        },
      ],
      fileList: [],
    }
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
      }
      if (formData.date.length) {
        formData.startTime = formData.date[0]
        formData.endTime = formData.date[1]
      }
      delete formData.date
      delete formData.pageSize

      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },
    // 提交
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          const { fileList } = this

          try {
            const { message } = await upload({
              ...values,
              file: fileList,
            })
            this.visible = false

            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 下载
    async handleDownload({ id }) {
      await download(id)
    },
    // 模板下载
    handleTemplateDownload() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          try {
            await templateDownload(values.type)
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 上传之前
    handleBeforeUpload(file) {
      this.fileList = [...this.fileList, file]
      this.fileList = this.fileList.slice(-1)
      return false
    },
    // 删除上传文件
    handleRemove(file) {
      const index = this.fileList.findIndex(item => item.uid === file.uid)
      this.remove(index)
    },
    // 本地删除
    remove(index) {
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    upload() {
      this.visible = true
      this.fileList = []
    },
  },
}
</script>

<style scoped lang="less">
.year-date {
  width: 100%;
}
</style>
